import {Head, Link, router} from "@inertiajs/react";
import {catalog_path, checkout_path, empty_cart_path, line_item_path, product_path} from "@/routes.js";
import clsx from "clsx";
import {useCart} from "@/contexts/cart.jsx";
import formatMoney from "~/utils/formatMoney.js";
import pageTitle from "~/utils/pageTitle.js";
import {Button} from "~/components/ui/button.jsx";
import {InfoIcon, Trash} from "lucide-react";
import {Card, CardAction, CardContent, CardFooter, CardHeader, CardTitle} from "~/components/ui/card.jsx";
import {Input} from "~/components/ui/input.jsx";
import {Label} from "~/components/ui/label.jsx";
import {Alert, AlertDescription, AlertTitle} from "~/components/ui/alert.jsx";
import {Heading} from "@/components/ui/heading.jsx";

const propertiesBlackList = [
  'Минимальное количество',
  'Праздник1',
  'Скидка не распостраняется'
]
export default function Cart({cart}) {
  const {total, line_items} = cart;
  const {deleteLineItem, setLineItemQuantity} = useCart()
  const isEmpty = line_items.length === 0;

  const handleEmptyCardButtonClick = () => router.delete(empty_cart_path())
  return (
    <>
      <Head title={pageTitle("Корзина")}/>
      <div className="container mx-auto py-8">
        <div className="px-2">
          <section>
            <header className="">
              <Heading size="h1">Ваша корзина</Heading>
            </header>
            <div className="mx-auto py-8 ">
              <div className="flex flex-wrap">
                <div className="w-full xl:w-2/3 xl:pr-16 space-y-8">
                  {isEmpty && (
                    <Alert className="text-base">
                      <InfoIcon/>
                      <AlertTitle>Корзина пуста!</AlertTitle>
                      <AlertDescription className="text-base">
                        В вашей корзине нет ни одного товара
                      </AlertDescription>
                    </Alert>
                  )}
                  <ul className="space-y-4 divide-y divide-gray-100">
                    {line_items.map((li => {
                      const {quantity, product, variant, price, pre_tax_amount} = li;
                      const {total_on_hand, product_properties, name} = product;
                      const image = product.thumbnail

                      return (
                        <li className="flex items-center gap-4 pb-4 xl:pb-8 flex-wrap">
                          <div className="size-20 flex-none rounded overflow-hidden">
                            <Link href={product_path(product.slug)}>
                              <img src={image.url} loading="lazy" className="size-20"
                                   alt={product.name}/>
                            </Link>
                          </div>

                          <div className="flex flex-1">
                            <h3 className="text-gray-900 text-base xl:text-xl">
                              <Link href={product_path(product.slug)}>{name}</Link>
                            </h3>
                          </div>

                          <div className="flex w-full xl:w-auto items-center justify-end gap-2">
                            <div className="">
                              <span className="text-gray-600 text-xs">{formatMoney(price)} &times; {quantity}</span>
                              <br/>{formatMoney(pre_tax_amount)}</div>

                            <div className="flex space-x-2 hidden">
                              <button
                                disabled={quantity <= 1}
                                onClick={() => router.patch(line_item_path(li.id), {quantity: li.quantity - 1})}
                              >-
                              </button>
                              <button
                                disabled={quantity >= total_on_hand}
                                onClick={() => router.patch(line_item_path(li.id), {quantity: li.quantity + 1})}
                              >+
                              </button>
                            </div>
                            <Button variant="outline" size="icon" onClick={() => {
                              router.delete(line_item_path(li.id))
                              deleteLineItem(li)
                            }}><Trash/></Button>

                          </div>
                        </li>

                      )

                    }))}
                  </ul>
                </div>
                <div className="w-full xl:w-1/3">
                  <div className="sticky top-20 space-y-8">
                    <Card>
                      <CardHeader>
                        <CardTitle>Промокод</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <form>
                          <div className='grid gap-4'>
                            {/*<Label>Промокод</Label>*/}
                            <p>У меня есть промокод!</p>
                            <Input size="xl" type="text" placeholder="Промокод"/>
                            <Button size="xl" color={'pink'}>Применить</Button>
                          </div>
                        </form>
                      </CardContent>
                    </Card>

                    <Card>
                      <CardHeader>
                        <CardTitle>Заказ {cart.number}</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="flex justify-end">
                          <div className="w-screen max-w-lg space-y-4">
                            <dl className="space-y-4 text-gray-700">
                              <div className="flex justify-between">
                                <dt>Скидка</dt>
                                <dd>---</dd>
                              </div>

                              <div className="flex justify-between !text-base font-medium">
                                <dt>Всего</dt>
                                <dd>{formatMoney(total)}</dd>
                              </div>
                            </dl>

                            <div className="flex justify-end">

                            </div>

                            <div className="flex justify-end">
                            </div>
                          </div>
                        </div>
                      </CardContent>

                      <CardFooter>
                        <CardAction className="flex w-full justify-between ">
                          <Button onClick={handleEmptyCardButtonClick} variant="ghost">
                            Очистить
                          </Button>
                          <Button size="xl" color={'pink'} disabled={isEmpty}
                                  onClick={() => router.visit(checkout_path())}>
                            Оформить заказ
                          </Button>
                        </CardAction>
                      </CardFooter>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}